import {
  takeEvery,
  select,
  put,
} from 'redux-saga/effects';

import { DELIVERY_STATUSES } from 'features/order-tracker/utils/entries';
import { ORDER_STATUS_IN_PROGRESS, ORDER_STATUS_COMPLETED } from 'features/order-tracker/services/constants';
import { RETRIEVE_ORDER_STATUS, setOrderStatusToStore } from 'features/order-tracker/store/actions';

interface StatusesState {
  orderStatusFromGOC: string;
  orderStatusFromOrderSummary: string;
  orderStatusFromTrackingEvents: string;
}

export function* getAPIStatuses(): Generator {
  const {
    orderStatusFromGOC,
    orderStatusFromOrderSummary,
    orderStatusFromTrackingEvents,
  } = (yield select((state: { statuses: StatusesState }) => state.statuses)) as StatusesState;

  let orderStatus: string;

  const isOrderCompletedFromTackingEvents = orderStatusFromTrackingEvents === DELIVERY_STATUSES.Delivered
      || orderStatusFromTrackingEvents === '';

  if (!orderStatusFromGOC) {
    orderStatus = orderStatusFromOrderSummary;
    if (orderStatusFromOrderSummary === ORDER_STATUS_COMPLETED) {
      if (isOrderCompletedFromTackingEvents) {
        orderStatus = ORDER_STATUS_COMPLETED;
      } else if (orderStatusFromTrackingEvents === DELIVERY_STATUSES.InProgress) {
        orderStatus = ORDER_STATUS_IN_PROGRESS;
      }
    }

    return yield put(setOrderStatusToStore({ orderStatus }));
  }

  const isOrderCompletedFromGOCAndOrderSummary = ORDER_STATUS_COMPLETED === orderStatusFromGOC
      && ORDER_STATUS_COMPLETED === orderStatusFromOrderSummary;

  if (isOrderCompletedFromGOCAndOrderSummary && isOrderCompletedFromTackingEvents) {
    orderStatus = ORDER_STATUS_COMPLETED;
  } else if (isOrderCompletedFromGOCAndOrderSummary && orderStatusFromTrackingEvents === DELIVERY_STATUSES.InProgress) {
    orderStatus = ORDER_STATUS_IN_PROGRESS;
  } else if (orderStatusFromGOC === ORDER_STATUS_COMPLETED) {
    orderStatus = ORDER_STATUS_IN_PROGRESS;
  } else {
    orderStatus = orderStatusFromGOC;
  }

  return yield put(setOrderStatusToStore({ orderStatus }));
}

export function* watchOrderStatus(): Generator {
  yield takeEvery(RETRIEVE_ORDER_STATUS, getAPIStatuses);
}
